<template>
  <div>
    <PlatformPve
      ref="platform"
      :bridge="bridge"
      :localStoragePrefix="localStoragePrefix"
      :buttons="buttons"
      :outputs="outputs"
      :uarts="uarts"
      :leds="leds"
      :languages="languages"
      :vbusSpecifications="vbusSpecifications"
      displayType="NT7538"
      @initialized="platformInitialized"
    ></PlatformPve>
  </div>
</template>

<script>
import { BasicPlatformWasiBridge } from '@/bridges/BasicPlatformWasiBridge';

import PlatformPve from '@/device-platforms/PlatformPve.vue';

const SpecificationFile = require('resol-vbus/src/specification-file');
const Specification = require('resol-vbus/src/specification');

export default {
  props: [
    'localStoragePrefix',
  ],

  components: {
    PlatformPve,
  },

  data: () => ({
    label: 'RESOL DeltaTherm PV 1.04',
    wasmUrl:'/100000165_DeltaThermPv_1d04-rc1plus-DW-SS.wasm',
    wasmModule: null,
    bridge: null,
    vbusSpecifications: [],

    buttons: [
      { platformIndex: 0,conversion: 'voltage', value: null, initialValue: 12.3, name: '??', }, // Pt1000
      { platformIndex: 1,conversion: 'resistorPt1000Temperature', value: null, initialValue: 52.3, name: 'S1', }, // Pt1000
      { platformIndex: 2,conversion: 'resistorPt1000Temperature', value: null, initialValue: 62.3, name: 'S2', }, // Pt1000
      { platformIndex: 3,conversion: 'resistorPt1000Temperature', value: null, initialValue: 72.3, name: 'S3', }, // Pt1000
      { platformIndex: 4,conversion: 'resistorNTC_MF58_5K_B35Temperature', value: null, initialValue: 12.3, name: 'S4', }, // NTC
      { platformIndex: 5,conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S5', }, // Pt1000
    ],
    outputs: [
      { name: 'PWM', conversion: 'dutycyclePercent', value: null }, //
      { name: 'DOut1', conversion: 'dutycyclePercent', value: null }, //
      { name: 'DOut2', conversion: 'dutycyclePercent', value: null }, //
      { name: 'R1', conversion: 'dutycyclePercent', value: null }, //
      { name: 'R2', conversion: 'dutycyclePercent', value: null }, //
      { name: 'FAN', conversion: 'dutycyclePercent', value: null }, //
    ],

    leds: [
        { state: null }
    ],

    uarts: [
      { name: 'UART0', kind: 'VBus', label: 'GP' },
      { name: 'UART1', kind: 'VBus', label: 'DDS' },
    ],

    languages: [
      { value: 0, text: 'Deutsch', short: 'de' },
      { value: 1, text: 'English', short: 'en' },
      { value: 2, text: 'ES', short: 'es' },
      { value: 3, text: 'FR', short: 'fr' },
      { value: 4, text: 'IT', short: 'it' },
      { value: 5, text: 'NL', short: 'nl' },
    ],
  }),

  created() {
  },

  mounted() {
  },

  methods: {
    async prepareDevice() {
      const response = await fetch(this.wasmUrl);
      const wasmArrayBuffer = await response.arrayBuffer();
      // console.log(wasmArrayBuffer);

      this.wasmModule = await WebAssembly.compile(wasmArrayBuffer);
      // console.log(this.wasmModule);

      this.bridge = new BasicPlatformWasiBridge(this.wasmModule);
      await this.bridge.instantiate();

      this.$refs.platform.prepareBridgeable();

      const vsfResponse = await fetch('/vbus_specification.vsf');
      const vsfArrayBuffer = await vsfResponse.arrayBuffer();
      const vsfBuffer = Buffer.from(vsfArrayBuffer);
      const specificationFile = new SpecificationFile(vsfBuffer);
      const specification = new Specification({ specificationFile });
      this.vbusSpecifications.push(specification);
    },

    startDevice() {
      this.bridge.start();
    },

    restartDevice() {},

    platformInitialized() {
    },
  },
};
</script>

<style>

</style>
